import React from "react";
import BaseModal from "./BaseModal";
import { useBatchChangeOwner } from "show/list/hooks/apis";
import UserModalPicker from "components/Picker/UserPicker/UserModalPicker";

interface Props {
  mainArea: server.dto.MainAreas
  onClose: () => void
}

const ChangeOwnerModal = (props: Props) => {
  const [owner, setOwner] = React.useState<server.dto.UserSmall>();

  const changeOwnerMutation = useBatchChangeOwner(props.mainArea);

  const applyChanges = async () => changeOwnerMutation.mutateAsync(owner.userId);

  return <BaseModal
    mainArea={props.mainArea}
    action="change"
    onClose={props.onClose}
    title={RESX.Planning.ChangeOwner}
    hasSelectedValue={owner != null}
    api={applyChanges}
  >
    <UserModalPicker
      canChooseDeactivated
      canCreateNew={false}
      nonInPageEditing={{
        onChange: setOwner,
        value: owner,
        required: false,
        validatorKey: "owner",
      }}
    />
  </BaseModal>;
};

export default ChangeOwnerModal;